import {
  DELETE,
  GET,
  PUT,
  UPLOAD_FILE,
  UPLOAD_FILE_WITH_METHOD,
} from "../../apiController";

const endpoint = "/admin/users";

// ---------------------- Users 

export const getOrgUsers = (data) => {
  const params = new URLSearchParams({
    page: data.page,
    limit: data.limit,
    status: data.state,
    search: data.search || "",
  });

  if (data.roleId && data.roleId !== "all") {
    params.set("role_id", data.roleId);
  }

  return GET(`${endpoint}?${params.toString()}`);
};

export const deleteUser = async (user_id) => {
  return DELETE(endpoint + `/delete-user/${user_id}`);
};

export const toggleUserStatus = (user_id, status) => {
  return PUT(endpoint + `/toggle-user-status/${user_id}`, { status });
};

export const createAdminUser = (data) => {
  return UPLOAD_FILE(endpoint + `/create-admin-user`, data);
};

export const editOrganisationUser = (data, userId) => {
  return UPLOAD_FILE_WITH_METHOD(endpoint + `/edit-user/${userId}`, data, 'PUT');
};

export const getRolesAndPermissions = (data) => {
  return GET(
    endpoint +
      `/roles?page=${data.page}&limit=${data.limit}&status=${data.state}&search=${data.search}`
  );
};
